<div class="pageTitle">
  <button class="popBtns" (click)="closePage()" title="close">
    <i class="fas fa-times"></i>
  </button>
  <h1 class="profile-header">DIGITAL WALLET</h1>
</div>
<div class="well">
  <form class="form-horizontal">

    <div class="row">
      <div class="col-md-12">
        <div class="subscription-title">
          PAYMENT SETUP - CUSTOMER DETAILS
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        CUSTOMER NAME *
      </div>
      <div class="col-md-7">
        <input type="text">
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        EMAIL
      </div>
      <div class="col-md-7">
        <input type="email">
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        ADDRESS LINE 1
      </div>
      <div class="col-md-7">
        <input type="text">
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        ADDRESS LINE 2
      </div>
      <div class="col-md-7">
        <input type="text">
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        SUBURB
      </div>
      <div class="col-md-7">
        <input type="text">
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        STATE
      </div>
      <div class="col-md-7">
        <select class="custom-dropdown custom-dropdown-sm" (change)="changeState($event.target.value)">
          <option *ngFor="let state of stateList" [value]="state" [selected]="state == stateList[0]">{{state}}</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        POST CODE
      </div>
      <div class="col-md-7">
        <input type="text">
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        PHONE
      </div>
      <div class="col-md-7">
        <input type="text">
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        COMPANY WIDE USE
      </div>
      <div class="col-md-7">
        <input type="checkbox" class="form-check-input" id="companyUse">
        <i class="master-tooltip info-icon info-icon-red" style="display:inline-block;margin-left: 16px;" title="Show this payment method everyone in your company to use"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        MAX AUTHORISED AMT
      </div>
      <div class="col-md-7">
        <input type="number">
        <i class="master-tooltip info-icon info-icon-red" style="display:inline-block;" title="Show this payment method everyone in your company to use"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <button type="button" class="button button-red button-mid confirmButton">Next</button>
      </div>
    </div>
  </form>
</div>